import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinChanges = lazyWithPreload(
  () => import('./DoubleChinChanges'),
)
